module.exports = __webpack_public_path__ + "static/media/login-logo.2f3fb3e4.png";